export default __webpack_public_path__ + "static/hairwash2_demeler-min-2d896636b321fdbe15a458884b043f74.png";